<section class="btn-group w-100" role="group" [ngStyle]="{ width }">
  <ng-container *ngFor="let item of items; let i = index">
    <input
      type="radio"
      [(ngModel)]="radioValue"
      (change)="onChange(item.value);"
      [value]="item.value"
      [name]="groupId"
      [disabled]="item.disabled"
      [ngClass]="{}"
      id="btnradio-{{ item.value }}-{{ groupId }}"
      class="btn-check checked"
      autocomplete="off"
    >
    <label
      [style.min-width.px]="minButtonWidthPx"
      class="btn {{radioValue === item.value ? checkedButtonClass : uncheckedButtonClass}} d-inline-block"
      for="btnradio-{{ item.value }}-{{ groupId }}"
      [ngClass]="{active: radioValue === item.value, disabled: item.disabled, 'mr-2': indentation, 'not-first': i !== 0}"
    >
      <p [innerHTML]="item.name | titlecase"></p>
    </label>
  </ng-container>
</section>
